import { ERROR_FORM_REQUEST_GENERIC } from './formErrors'

export class NetworkError extends Error {
  constructor(error) {
    super(error.message)
    this.name = this.constructor.name
    this.wrappedError = error
    this.data = {
      errors: [ERROR_FORM_REQUEST_GENERIC],
    }
  }
}

export class StatusError extends Error {
  constructor(status, statusText, data) {
    super(`${status} (${statusText})`)
    this.name = this.constructor.name
    this.status = status
    this.statusText = statusText

    this.dataHasErrors =
      (!!data?.fieldErrors && Object.keys(data.fieldErrors).length !== 0) ||
      (!!data?.errors && data.errors.length !== 0)

    data = data ?? {}

    this.data = {
      ...data,
      errors: this.dataHasErrors
        ? data?.errors ?? null
        : [ERROR_FORM_REQUEST_GENERIC],
    }
  }
}

export class JSONError extends Error {
  constructor(error) {
    super(error.message)
    this.name = this.constructor.name
    this.wrappedError = error
    this.data = {
      errors: [ERROR_FORM_REQUEST_GENERIC],
    }
  }
}

const enhancedFetch = async (
  method,
  url,
  { parseJSON, data, throwOnError = true, ...options } = {},
) => {
  const headers = options.headers ?? {}

  if (parseJSON) {
    headers['Accept'] = 'application/json'
  }

  let body
  if (data instanceof FormData) {
    body = data
  } else if (data) {
    body = JSON.stringify(data)
    headers['Content-Type'] = 'application/json'
  }

  let res
  try {
    res = await fetch(url, {
      method,
      credentials: 'include',
      ...options,
      headers,
      body,
    })
  } catch (e) {
    throw new NetworkError(e)
  }

  if (!res.ok && res.status !== 204) {
    let errData
    try {
      errData = await res.json()
    } catch (e) {
      // Ignorar errores de parsing
    }

    if (throwOnError) {
      throw new StatusError(res.status, res.statusText, errData)
    } else {
      return {
        res,
        data: null,
      }
    }
  }

  if (res.status === 204) {
    return {
      res,
      data: {}, // Devolver un objeto vacío para respuestas 204
    }
  }

  let resData
  if (parseJSON) {
    try {
      resData = await res.json()
    } catch (e) {
      if (!res.url.includes('rpc-cancel-shipping-by-shipping-code')) {
        throw new JSONError(e)
      }
    }
  } else {
    resData = await res.text()
  }

  return {
    res,
    data: resData,
  }
}

export default enhancedFetch
